import internalStaticConfig from './internal';
import publicStaticConfig from './public';
import baseStaticConfig from './base';

const getStaticConfig = () => {
  switch (process.env.NEXT_PUBLIC_STATIC_CONFIG_ENV) {
    case 'internal':
      return internalStaticConfig;
    case 'public':
      return publicStaticConfig;
    default:
      return baseStaticConfig;
  }
};

const staticConfig = getStaticConfig();

export default staticConfig;
